import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myBase64Prefix'
})
export class Base64PrefixPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    const regexp = /^data:image\/[a-z]+;base64,/;
    if (value) {
      try {
        window.atob(value);
        value.replace(regexp, '');
        return 'data:image/*;base64, ' + value;
      } catch (e) {
        return value;
      }
    }
    return null;
  }
}
